export const textIsLink = (text: string) => {
	return new RegExp(`^https?:`).test(text);
};
